export default function FreeTrigger() {
  return (
    <div className="flex w-full bg-[#333333] mb-1">
      <div className="h-11 m-1 flex items-center mx-auto">
        <h2 className="font-bold">FREE TRIGGER</h2>
      </div>
    </div>
  );
}